"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLink = createLink;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Link =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, _getPrototypeOf(Link).apply(this, arguments));
  }

  _createClass(Link, [{
    key: "click",
    value: function click(e) {
      e.preventDefault();
      this.props.request.to(this.props.to);
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("a", {
        href: this.props.to,
        className: this.props.className,
        onClick: this.click.bind(this)
      }, this.props.children);
    }
  }]);

  return Link;
}(_react.default.Component);

function createLink(request) {
  return function (props) {
    return _react.default.createElement(Link, _extends({
      request: request
    }, props));
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9saWIvTGluay5qcyJdLCJuYW1lcyI6WyJMaW5rIiwiZSIsInByZXZlbnREZWZhdWx0IiwicHJvcHMiLCJyZXF1ZXN0IiwidG8iLCJjbGFzc05hbWUiLCJjbGljayIsImJpbmQiLCJjaGlsZHJlbiIsIlJlYWN0IiwiQ29tcG9uZW50IiwiY3JlYXRlTGluayJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUFFTUEsSTs7Ozs7Ozs7Ozs7OzswQkFDRUMsQyxFQUFHO0FBQ1BBLE1BQUFBLENBQUMsQ0FBQ0MsY0FBRjtBQUNBLFdBQUtDLEtBQUwsQ0FBV0MsT0FBWCxDQUFtQkMsRUFBbkIsQ0FBc0IsS0FBS0YsS0FBTCxDQUFXRSxFQUFqQztBQUNEOzs7NkJBRVE7QUFDUCxhQUNFO0FBQ0UsUUFBQSxJQUFJLEVBQUUsS0FBS0YsS0FBTCxDQUFXRSxFQURuQjtBQUVFLFFBQUEsU0FBUyxFQUFFLEtBQUtGLEtBQUwsQ0FBV0csU0FGeEI7QUFHRSxRQUFBLE9BQU8sRUFBRSxLQUFLQyxLQUFMLENBQVdDLElBQVgsQ0FBZ0IsSUFBaEI7QUFIWCxTQUtHLEtBQUtMLEtBQUwsQ0FBV00sUUFMZCxDQURGO0FBU0Q7Ozs7RUFoQmdCQyxlQUFNQyxTOztBQW1CbEIsU0FBU0MsVUFBVCxDQUFvQlIsT0FBcEIsRUFBNkI7QUFDbEMsU0FBTyxVQUFDRCxLQUFELEVBQVc7QUFDaEIsV0FBTyw2QkFBQyxJQUFEO0FBQU0sTUFBQSxPQUFPLEVBQUVDO0FBQWYsT0FBNEJELEtBQTVCLEVBQVA7QUFDRCxHQUZEO0FBR0QiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5cbmNsYXNzIExpbmsgZXh0ZW5kcyBSZWFjdC5Db21wb25lbnQge1xuICBjbGljayhlKSB7XG4gICAgZS5wcmV2ZW50RGVmYXVsdCgpO1xuICAgIHRoaXMucHJvcHMucmVxdWVzdC50byh0aGlzLnByb3BzLnRvKTtcbiAgfVxuXG4gIHJlbmRlcigpIHtcbiAgICByZXR1cm4gKFxuICAgICAgPGFcbiAgICAgICAgaHJlZj17dGhpcy5wcm9wcy50b31cbiAgICAgICAgY2xhc3NOYW1lPXt0aGlzLnByb3BzLmNsYXNzTmFtZX1cbiAgICAgICAgb25DbGljaz17dGhpcy5jbGljay5iaW5kKHRoaXMpfVxuICAgICAgPlxuICAgICAgICB7dGhpcy5wcm9wcy5jaGlsZHJlbn1cbiAgICAgIDwvYT5cbiAgICApO1xuICB9XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBjcmVhdGVMaW5rKHJlcXVlc3QpIHtcbiAgcmV0dXJuIChwcm9wcykgPT4ge1xuICAgIHJldHVybiA8TGluayByZXF1ZXN0PXtyZXF1ZXN0fSB7Li4ucHJvcHN9IC8+O1xuICB9O1xufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./node_modules/async-react-router/lib/Link.js
// module id = 135
// module chunks = 0